import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm';
import { Modal, Accordion } from 'react-bootstrap'
import { PageHeader, StatusBadge } from '../../ui'

export default function RateUpdate() {
    const [lgShow, setLgShow] = useState(false);
    const [accessType, setAccessType] = useState('')

    //API call
    useEffect(() => {

        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);

        if (foundUser.role_capabilities?.all_modules_access === true) {

            setAccessType('Edit');

        }
        else {

            setAccessType(foundUser.access['RateUpdate_Access Specifier']);
        }

    }, []);


    return (
        <>
            <PageHeader
                title="Rate Update"
                subtitle="Load, review, copy, import, and update rates for the selected account and location."
                eyebrow="Rate management"
                help={(
                    <button type="button" className="btn btn-outline-primary" onClick={() => setLgShow(true)}>
                        Help
                    </button>
                )}
            >
                {accessType === 'View' && <StatusBadge status="neutral">View only</StatusBadge>}
            </PageHeader>

            <Modal
                            size="lg"
                            show={lgShow}
                            onHide={() => setLgShow(false)}
                            aria-labelledby="rate-update-help-title">
                            <Modal.Header closeButton>
                                <Modal.Title id="rate-update-help-title" >
                                    Instructions for Rate Update
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                                <style>{`
                                  .help-badge {
                                    padding: 4px 10px;
                                    border-radius: 16px;
                                    font-weight: 700;
                                    font-size: 12px;
                                    text-transform: uppercase;
                                    letter-spacing: 0.5px;
                                    margin-right: 10px;
                                  }
                                  .badge-create { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                                  .badge-copy   { background: #ebf8ff; color: #2b6cb0; border: 1px solid #bee3f8; }
                                  
                                  .help-card-text {
                                    font-size: 14px;
                                    color: #4a5568;
                                    line-height: 1.5;
                                    margin-bottom: 16px;
                                  }
                                  .video-responsive-wrapper {
                                    position: relative;
                                    width: 100%;
                                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                                    border-radius: 8px;
                                    overflow: hidden;
                                    background: #000000;
                                  }
                                  .video-responsive-wrapper video {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                  }
                                  .accordion-button:not(.collapsed) {
                                    background-color: #f1f5f9;
                                    color: #1e293b;
                                  }
                                `}</style>

                                <Accordion defaultActiveKey="0" flush>

                                  {/* 1. CREATE / UPDATE / DOWNLOAD & UPLOAD RATES */}
                                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-create">Create / Update / Download</span>
                                      <strong>How to Create, Update & Download Rates</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        To update rates, select the <strong>Account Name</strong>, <strong>Location Name</strong>, <strong>Rate Code</strong>, date range, and required days. Click <strong>Preload</strong> to view existing rates, make the required changes, and click <strong>Update</strong>. Rate Codes with existing rate rules will not be displayed, but the applicable rules will be applied automatically.
                                        <br /><br />
                                        Rates can be downloaded in two ways: existing rate data can be downloaded based on criteria, or a blank Excel template can be downloaded with required dates, Rate Codes, and Car Classes. Once updated, upload it using the <strong>Upload Excel</strong> option. Use the <strong>Clear</strong> option to remove rates.
                                        <br /><br />
                                        <em>Note: Rates cannot be preloaded when <strong>Select All Days</strong> is checked.</em>
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/rate - create - update.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                  {/* 2. COPY RATES */}
                                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-copy">Copy</span>
                                      <strong>How to Copy Rates</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        To copy rates, select the Account, Location, and Rate Code, then click <strong>Copy Rates</strong>. Select the source Location and Rate Code, review the rates by date, make any required changes, select the target rates, and click <strong>Copy Rates</strong> to update the destination location.
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/rate - copy.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                </Accordion>
                            </Modal.Body>
            </Modal>

            {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}
        </>
    );
}
